// Paletas precargadas de "Aventura Espacial" (cumpleaños infantil).
// "terciario" alimenta cohete, planetas y acentos lúdicos.
const FUENTES = {
  display: '"Fredoka", system-ui, sans-serif',
  cuerpo: '"Quicksand", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "espacio",
    nombre: "Espacio",
    tema: {
      colores: {
        fondo: "#EEF3FC",
        fondoAlt: "#E2EAF7",
        texto: "#1E2A45",
        textoSuave: "#4D5A75",
        textoTenue: "#8B97B0",
        primario: "#3B5BDB",
        primarioSuave: "#DCE4F8",
        acento: "#F5B301",
        terciario: "#E8590C",
        borde: "rgba(30, 42, 69, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "aurora",
    nombre: "Aurora",
    tema: {
      colores: {
        fondo: "#F0FAF6",
        fondoAlt: "#E1F3EC",
        texto: "#173830",
        textoSuave: "#49645B",
        textoTenue: "#84A298",
        primario: "#2F9E8F",
        primarioSuave: "#D8EEE9",
        acento: "#7C6BD9",
        terciario: "#F5B301",
        borde: "rgba(23, 56, 48, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "amanecer",
    nombre: "Amanecer",
    tema: {
      colores: {
        fondo: "#FFF4EC",
        fondoAlt: "#FDE9DC",
        texto: "#3A2417",
        textoSuave: "#6E5240",
        textoTenue: "#A8907E",
        primario: "#E8590C",
        primarioSuave: "#FBE0CE",
        acento: "#F5B301",
        terciario: "#3B5BDB",
        borde: "rgba(58, 36, 23, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
];
